import ChangeMethodModal from 'components/GlobalModals/ChangeMethodModal/ChangeMethodModal';
import { withChangeMethodModalProps } from 'viewModel/rwdBasket/changeMethodModal/withChangeMethodModalProps';

export default withChangeMethodModalProps(ChangeMethodModal);
